import React, {useState} from 'react';
import {Button} from "primereact/button";
import {webInfo} from "../../../../utils/webInfo";
import {FileUpload} from "primereact/fileupload";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import useDelete from "../../../../hooks/useDelete";
import usePost from "../../../../hooks/usePost";
import {Skeleton} from "primereact/skeleton";
import {Dialog} from "primereact/dialog";
import {catchError, getDivisionWiseUrl} from "../../../../utils/helper";
import {useParams, useSearchParams} from "react-router-dom";
import {Card} from "primereact/card";

const Keyfacts = ({product, setProduct,refresh, setRefresh}: any) => {
    const {id} = useParams();
    const {remove, loading: rloading} = useDelete();
    const {post, loading: ploading} = usePost();
    const [keyVisible, setKeyVisible] = useState<boolean>(false);
    const [searchParams] = useSearchParams();
    const division = searchParams.get("division");
    const [preview,setPreview] = useState("")
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const [keyfact, setKeyfact] = useState<any>({
        image: null,
        title: "",
        description: ""
    });

    const removeKeyfact = async (id: any) => {
        const url = `${webInfo.baseUrl}/api/admin/products-${getDivisionWiseUrl(division)?.url}/key-facts-delete/${id}`
        const res: any = await remove(url)
        if (res.success) {
            const filtered = product.key_facts.filter(
                (kf: any) => kf.id !== id
            );

            setProduct({
                ...product,
                key_facts: filtered
            });
        }
    }

    const handleKeyfact = (e: any, id: any) => {
        const key_fact: any = product?.key_facts?.map((item: any) => {
            if (item.id === id) {
                return {
                    ...item,
                    [e.target.name]: e.target.value
                }
            }
            return item;
        });
        setProduct({
            ...product,
            key_facts: key_fact
        })
    }


    const selectKeyFactImage = (e: any, id: any) => {
        const key_fact: any = product?.key_facts?.map((item: any) => {
            if (item.id === id) {
                return {
                    ...item,
                    image: e.files[0]
                }
            }
            return item;
        });
        setProduct({
            ...product,
            key_facts: key_fact
        })
    }

    const handleImage = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            setKeyfact({
                ...keyfact,
                image: file
            })
            setPreview(URL.createObjectURL(file));
        }
    };

    const uploadKeyfact = async () => {
        if (!keyfact.image) return;
            const formData = new FormData();
            formData.append("image", keyfact.image);
            formData.append("title", keyfact.title);
            formData.append("description", keyfact.description);
            const url = `${webInfo.baseUrl}/api/admin/products-${getDivisionWiseUrl(division)?.url}/key-facts-store/${id}`
            try {
                // @ts-ignore
                const res:any = await post(url,false,formData);
                if (res.success){
                    const newId = (product?.key_facts?.at(-1)?.id || 0) + 1;
                    setProduct({
                        ...product,
                        key_facts: [
                            ...product?.key_facts,
                            {
                                id:newId,
                                image: preview,
                                preview: true,
                                title: keyfact.title,
                                description: keyfact.description
                            }
                        ],
                    })
                    setKeyVisible(false)
                    setKeyfact({
                        image: null,
                        title: "",
                        description: ""
                    })
                    setPreview("")
                    setRefresh(!refresh)
                    if (fileInputRef.current) fileInputRef.current.value = "";
                }
            }catch (e) {
                catchError(e)
            }
    }

    return (
        <div className="mb-5">
            <Dialog
                header="Key Fact"
                visible={keyVisible}
                style={{width: "20vw"}}
                onHide={() => {
                    setKeyVisible(false)
                    setKeyfact({
                        image: null,
                        title: "",
                        description: ""
                    })
                    setPreview("")
                    if (fileInputRef.current) fileInputRef.current.value = "";
                }}
            >
                {
                    ploading ? <div>
                            <Skeleton className="w-full mb-2" height="16rem"></Skeleton>
                            <Skeleton className="w-full mb-2" height="3rem"></Skeleton>
                            <Skeleton className="w-full" height="3rem"></Skeleton>
                        </div> :
                        <div>
                            {preview && (
                                <div className="mb-3 text-center">
                                    <img
                                        src={preview}
                                        alt="preview"
                                        style={{
                                            width: "100%",
                                            maxHeight: "200px",
                                            objectFit: "cover",
                                            borderRadius: "6px",
                                        }}
                                    />
                                </div>
                            )}
                            <div className="flex flex-column gap-2 ">


                                <div className="p-inputgroup">

                                    <InputText
                                        readOnly
                                        value={keyfact.image instanceof File ? keyfact.image.name : "No file chosen"}
                                        placeholder="Choose Image"
                                        onClick={() => fileInputRef.current?.click()}
                                    />
                                    <Button
                                        type="button"
                                        icon="pi pi-upload"
                                        label="Browse"
                                        onClick={() => fileInputRef.current?.click()}
                                    />
                                </div>

                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    accept="image/*"
                                    onChange={handleImage}
                                />
                            </div>
                            <div className="my-2">
                                <InputText name={'title'} onChange={(e: any) => setKeyfact({
                                    ...keyfact,
                                    title: e.target.value
                                })}
                                           className="w-full" placeholder="Key Insides Title"/>
                            </div>
                            <div>
                                <InputTextarea name={'description'} onChange={(e: any) => setKeyfact({
                                    ...keyfact,
                                    description: e.target.value
                                })}
                                               className="w-full"
                                               placeholder="Key Insides Description"/>
                            </div>
                            <Button
                                className="w-full"
                                label="Upload"
                                onClick={uploadKeyfact}
                            />
                        </div>
                }
            </Dialog>
            <div className="flex justify-content-between mb-2">
                <h4 className="mb-3">Key Facts (Max 2 Item)</h4>
                <Button size={'small'} outlined icon={'pi pi-plus'} disabled={product?.key_facts?.length >= 2} onClick={() => setKeyVisible(true)}
                        label={'Add New'}/>
            </div>
            {
                product?.key_facts?.map((fact: any, index: any) => {
                    const img_type = typeof fact.image
                    // const objectUrl = fact.preview ? fact.image :img_type === 'string' ? `${webInfo.baseUrl}/${fact?.image}` : URL.createObjectURL(fact.image);
                    const objectUrl = !fact.image
                        ? webInfo.uploadImg
                        : fact.preview
                            ? fact.image
                            : img_type === "string"
                                ? `${webInfo.baseUrl}/${fact.image}`
                                : URL.createObjectURL(fact.image);
                    return <Card className="mb-3" key={fact.id}>
                        <label className="font-medium">Key Insides 0{index + 1}</label><br/>
                        <div className="flex align-items-center justify-content-between">
                            <div>
                                <div className="flex align-items-center">
                                    <div className="border-2 border border-gray-400 overflow-hidden "
                                         style={{height: '50px', width: '50px', borderRadius: '5px'}}>
                                        <img
                                            alt="Default"
                                            src={objectUrl} className="object-cover h-full w-full"/>
                                    </div>
                                    <FileUpload disabled className="ml-2" mode="basic" name="demo[]" url="/api/upload"
                                                accept="image/*" onSelect={(e) => selectKeyFactImage(e, fact.id)}/>
                                </div>
                            </div>
                            <Button  loading={rloading} onClick={() => removeKeyfact(fact.id)} severity={'danger'} size={'small'}
                                    icon={'pi pi-trash'} title={'Delete'}/>
                        </div>
                        <div className="my-2">
                            <InputText disabled name={'title'} onChange={(e: any) => handleKeyfact(e, fact.id)}
                                       value={fact?.title} className="w-full" placeholder="Key Insides Title"/>
                        </div>
                        <div>
                            <InputTextarea disabled name={'description'} onChange={(e: any) => handleKeyfact(e, fact.id)}
                                           value={fact?.description} className="w-full"
                                           placeholder="Key Insides Description"/>
                        </div>
                    </Card>
                })
            }
        </div>
    );
};

export default Keyfacts;